import React from 'react';

export interface Props {
  className?: string;
}

const Commission40: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M10.185 6.411l-1.096-1.02c-1.075-1.916 1.293-4.462 4.75-3.47.185.052.223.291.068.405-.327.24-.713.723-.76 1.67-.093 1.903-1.417 3.333-2.962 2.415zM9.212 6.929c.584.587.609 1.863.056 2.413-1.917 1.51-6.317 4.968-6.314 4.967l-.003.002c-.228.108-.588 0-.869-.281-.267-.267-.379-.607-.295-.835 0 0 3.752-4.752 5.012-6.335.553-.55 1.828-.518 2.413.069z"
    ></path>
  </svg>
);
Commission40.displayName = 'Commission40';

export default Commission40;
